import PropertySelect from 'components/PropertySelect';
import { PropertyType } from 'components/PropertySelect/PropertySelect';
import { Button, FormInput, Icon, moneyFormat } from 'modules';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';

export interface Property {
  druh: string | null;
  popis: string;
  cena: number;
}

interface PropertiesListProps {
  name: string;
  list: Property[];
  readOnly?: boolean;
  onChange: (e: React.ChangeEvent) => void;
}

const PropertiesList = ({ name, list, readOnly, onChange }: PropertiesListProps) => {
  const [newRow, setNewRow] = useState(true);
  const [newRowData, setNewRowData] = useState<Property>({
    druh: null,
    popis: '',
    cena: 0,
  });

  const onChangeNewRowData = (e: React.ChangeEvent) => {
    const { name, value } = e.target as HTMLInputElement;
    setNewRowData({
      ...newRowData,
      [name]: value,
    });
  };

  const isValid = (): boolean => {
    return newRowData.druh !== '' && (newRowData.druh === PropertyType.NO_PROPERTY || newRowData.cena > 0);
  };

  const onSaveNewRow = () => {
    if (isValid()) {
      setNewRow(false);
      const newList = [...list];
      newList.push(newRowData);
      onChange({
        target: {
          name,
          value: newList,
        },
      } as any);
      setNewRowData({
        druh: null,
        popis: '',
        cena: 0,
      });
      setNewRow(true);
    }
  };

  const onDeleteRow = (index: number): void => {
    const newList = list.filter((p, i: number) => i !== index);
    onChange({
      target: {
        name,
        value: newList,
      },
    } as any);
  };

  return (
    <>
      {list.map((a: Property, index: number) => {
        return (
          <Row key={index}>
            <Col sm={4}>
              <FormInput name="druh" value={a.druh} readOnly={true} />
            </Col>
            <Col sm={5}>
              <FormInput name="popis" value={a.popis} readOnly={true} />
            </Col>
            <Col sm={3} className="d-flex">
              <FormInput
                name="cena"
                className="text-right"
                value={a.druh !== PropertyType.NO_PROPERTY || a.cena > 0 ? moneyFormat(a.cena) : ''}
                readOnly={true}
              />
              {readOnly !== true && (
                <Button
                  type="button"
                  variant="danger"
                  className="btn-input-size ml-1"
                  onClick={() => onDeleteRow(index)}
                >
                  <Icon type="times" />
                </Button>
              )}
            </Col>
          </Row>
        );
      })}

      {newRow === true && readOnly !== true && (
        <Row>
          <Col sm={4}>
            <PropertySelect name="druh" value={newRowData.druh} onChange={onChangeNewRowData} />
          </Col>
          <Col sm={5}>
            <FormInput name="popis" placeholder="Popis" value={newRowData.popis} onChange={onChangeNewRowData} />
          </Col>
          <Col sm={3} className="d-flex">
            <FormInput
              type="number"
              name="cena"
              placeholder="Cena (EUR)"
              value={newRowData.cena}
              onChange={onChangeNewRowData}
            />
            <Button
              type="button"
              variant="primary"
              disabled={!isValid()}
              className="btn-input-size ml-1"
              onClick={onSaveNewRow}
            >
              <Icon type="check" />
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};

export default PropertiesList;
